export const RELATED_INFOS_SPACING = {
    section: 6,
    grid: 6,
    layout: 4,
    content: 2,
    text: 1,
    sidebar: 4,
    mobile: 3,
    dividerY: 6,
    columnY: 6,
} as const;
